import Container from "@components/Container/Container";

/**
 * Component to render Description of E50 on homepage
 */
const E50Description = (): React.ReactElement => {
  return (
    <Container
      rootClassName="flex flex-row justify-center px-0"
      data-testid="e50-description-component"
    >
      <div className="mb-6 flex w-full flex-col justify-center pl-3 text-center text-gray-850 md:pl-4 lg:w-11/12 lg:flex-row">
        <div className="w-full lg:w-4/12 lg:pr-4">
          <h2 className="mb-6 text-left font-poppins text-xl font-medium md:mb-2 md:mb-6 lg:mb-0 lg:pl-3 lg:text-8xl lg:leading-tight">
            {"Building a Resilient Nation: "}
            <br className="inline md:hidden" />
            {"Enterprises as Pillars of "}
            <br className="inline md:hidden" />
            {"Progress "}
          </h2>
        </div>

        <p className="text-md w-full pl-0 text-left font-public-sans leading-6 lg:w-8/12">
          Businesses that drive progress go beyond just adapting to change—they
          create new opportunities, strengthen ecosystems, and contribute to
          long-term economic success. True success means being resilient and
          being able to deliver real value that fuels growth and transformation.
          The Enterprise 50 Awards celebrate enterprises that are shaping
          industries, strengthening networks, and positioning Singapore for
          continued global relevance. If your company is making a meaningful
          impact on the economy and shaping the future of business, this is your
          opportunity to be recognized among the nation’s top leaders.
        </p>
      </div>
    </Container>
  );
};

export default E50Description;
